<template>
    <div :class="errorValue ? 'el-form-item is-error' : 'el-form-item'">
        <label class="block">{{label}} </label>
        <small> {{inputNote}} </small>
        <br>
        <el-input :class="'input-field'" :style="typeField ? 'width: 222px' : ''" :type="typeField" v-model="innerValue" :placeholder="placeholder" />

        <small v-if="errorValue" class="error-msg"> {{ errorValue }} </small>
    </div>
</template>

<script>
    import { bus } from "../../Bus";

    export default {
        name: 'InputField',
        props: {
            inputNote: {
                type: String,
                isRequired: false
            },
            label: {
                isRequired: true
            },
            typeField: {},
            error: {
                type: String
            },
            placeholder: {
                type: String
            },
            value: {}
        },
        watch: {
            value(val) {
                this.innerValue = val
            },
            innerValue(val) {
                this.$emit('input', val)
            },
            error () {
                this.errorValue = this.error;
            }
        },
        created() {
            bus.$on('clearInput', () => {
                this.innerValue = '';

            });
            bus.$on('clearError', () => {
                // if (this.errorValue !== undefined) {
                    this.errorValue = null
            });
        },
        data() {
            return {
                innerValue: this.value,
                errorValue: undefined
            }
        }
    }
</script>

<style scoped>
    .block {
        display: inline-block;
    }

    .el-form-item {
        margin-bottom: 0 !important;
    }

    .input-field {
        margin-top: 10px;
        margin-bottom: 10px;
    }
    .num-input-field {
        margin-top: 10px;
        margin-bottom: 10px;
        width: 100px;
    }
    
    .el-form-item.is-error > div {
        margin-bottom: 0;
    }

    .error-msg {
        color: red;
        margin-bottom: 5px;
        display: block;
        margin-top: 3px;
    }
</style>




// WEBPACK FOOTER //
// src/components/Inputs/InputField.vue